import { useEffect } from "react";
import { useLocation } from "wouter";

/**
 * Resets the window scroll position to the top whenever the route changes.
 * Must be rendered inside the WouterRouter so it can read the current location.
 */
export function ScrollToTop() {
  const [location] = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location]);

  return null;
}
